import TeamRankingGame from './TeamRankingGame';

function App() {
  return <TeamRankingGame />;
}

export default App;
